import { manualUnavailable } from '../../presentation/manual-access.js';
import { listNotice, EXPIRED_ACTION_NOTICE } from '../../presentation/list-copy'
// 公共交互边界：只读、整轮阻断、忙碌和过期时禁止发送动作。新增组件不得绕过此约束。
import { componentSupport } from '@/ai/protocol/component-support'
import AiNotice from '../AiCompatibilityNotice.vue'
import AiIcon from '@/components/common/icons/AiIcon.vue'
export default {
 components: { AiIcon, AiNotice },
 inject: { aiPageState: { default: null } },
 props: {card:Object,blocked:Boolean,busy:Boolean,actionBusy:Boolean,pagination:{type:Object,default:()=>({})},readOnly:Boolean,now:Number},
 computed: {
  manualDisabled() { return manualUnavailable({ blocked: this.blocked, busy: this.busy, valid: !this.aiPageState || this.aiPageState.valid }) },
  known() { return componentSupport(this.card) !== 'unsupported' },
  expired() { return this.card.interaction && Date.parse(this.card.interaction.expiresAt) <= this.now },
  expiryNotice() { return this.expired && !this.readOnly ? EXPIRED_ACTION_NOTICE : '' },
  disabled() { return this.readOnly || this.blocked || this.busy || this.expired }
 },
 methods: {
    listNotice(card, pagination) { return listNotice(card, pagination) },
    send(kind, input) {
      if (this.card.interaction && Date.parse(this.card.interaction.expiresAt) <= Date.now()) return
      if (!this.disabled) this.$emit('action', { card: this.card, kind, input })
    }
 }
}
